import React, {
    ReactElement,
} from "react";
import {
    Route, Routes as BrowserRoutes,
} from "react-router-dom";
import AuthRoute from "./components/AuthRoute";
import useRouting from "./contexts/Routing";
import CreateAccount from "./pages/account/create/CreateAccount";
import AccountDetails from "./pages/account/details/AccountDetails";
import LoginWithToken from "./pages/account/login-with-token/LoginWithToken";
import Login from "./pages/account/login/Login";
import PasswordChange from "./pages/account/password-change/PasswordChange";
import PasswordReset from "./pages/account/reset-password/ResetPassword";
import Users from "./pages/account/users/Users";
import Administrator from "./pages/administrator/Administrator";
import SiteAdministrator from "./pages/site-admin/Administrator";

import AgentRoutes from "./pages/agent/AgentRoute";
import AnswerDetails from "./pages/answers/details/AnswerDetails";
import AnswerList from "./pages/answers/list/AnswerList";
import ChannelInvite from "./pages/channel-invite/ChannelInvite";
import { Error404, ErrorDefault } from "./pages/error/Error";
import Homepage from "./pages/homepage/Homepage";
import Tickets from "./pages/tickets/Tickets";
import Contacts from "./pages/contacts/Contacts";
import OrganizationDetail from "./components/contacts/OrganizationDetail";
import UserDetail from "./components/contacts/UserDetail";
import ContactUsers from "./components/contacts/Users";
import Onboarding from "./pages/onboarding/Onboarding";

function InternalError() {
    return <ErrorDefault message="Interal Error" />;
}

function Routes(): ReactElement {
    const { Paths } = useRouting();
    return (
        <BrowserRoutes>
            <Route path={Paths.ACCOUNT_CREATE_ID} element={<CreateAccount />} />
            <Route path={Paths.ACCOUNT_CREATE} element={<CreateAccount />} />

            <Route path={Paths.ANSWERS_NEW} element={<AuthRoute><AnswerDetails /></AuthRoute>} />
            <Route path={Paths.ANSWERS_GET} element={<AnswerDetails />} />
            <Route path={Paths.ANSWERS_LIST} element={<AnswerList />} />

            <Route path="agent/*" element={<AuthRoute><AgentRoutes /></AuthRoute>} />

            <Route path={Paths.TICKETS} element={<AuthRoute><Tickets /></AuthRoute>} />
            <Route path={Paths.TICKETS_CREATE} element={<AuthRoute><Tickets /></AuthRoute>} />
            <Route path={Paths.TICKETS_VIEW} element={<AuthRoute><Tickets /></AuthRoute>} />

            <Route path={Paths.CONTACTS} element={<AuthRoute><Contacts /></AuthRoute>} />
            <Route path={Paths.CONTACTS_ENTITY} element={<AuthRoute><Contacts /></AuthRoute>} />

            <Route
                path={Paths.ORGANIZATION_USERS}
                element={(
                    <AuthRoute>
                        <Contacts
                            title="Users"
                        >
                            <ContactUsers />
                        </Contacts>
                    </AuthRoute>
                )}
            />
            <Route
                path={Paths.ORGANIZATIONS_ID}
                element={(
                    <AuthRoute>
                        <Contacts
                            title="Organizations"
                        >
                            <OrganizationDetail />
                        </Contacts>
                    </AuthRoute>
                )}
            />
            <Route
                path={Paths.ORGANIZATIONS_NEW}
                element={(
                    <AuthRoute>
                        <Contacts title="Organizations">
                            <OrganizationDetail />
                        </Contacts>
                    </AuthRoute>
                )}
            />
            <Route
                path={Paths.USERS_ID}
                element={(
                    <AuthRoute>
                        <Contacts
                            title="Users"
                        >
                            <UserDetail />
                        </Contacts>
                    </AuthRoute>
                )}
            />
            <Route
                path={Paths.USERS_NEW}
                element={(
                    <AuthRoute>
                        <Contacts title="Users">
                            <UserDetail />
                        </Contacts>
                    </AuthRoute>
                )}
            />
            <Route path={Paths.ONBOARDING} element={<AuthRoute><Onboarding /></AuthRoute>} />
            <Route path={Paths.ONBOARDING_STEP} element={<AuthRoute><Onboarding /></AuthRoute>} />

            <Route path={Paths.ACCOUNT_PASSWORD} element={<AuthRoute><PasswordChange /></AuthRoute>} />
            <Route path={Paths.ACCOUNT_PROFLE} element={<AuthRoute><AccountDetails /></AuthRoute>} />
            <Route path={Paths.LOGIN} element={<Login />} />
            <Route path={Paths.LOGIN_WITH_TOKEN} element={<LoginWithToken />} />
            <Route path={Paths.LOGIN_RESET} element={<PasswordReset />} />

            <Route path={Paths.ADMINISTRATOR_SETTING_ID} element={<AuthRoute><Administrator /></AuthRoute>} />
            <Route path={Paths.ADMINISTRATOR_SETTING} element={<AuthRoute><Administrator /></AuthRoute>} />
            <Route path={Paths.ADMINISTRATOR} element={<AuthRoute><Administrator /></AuthRoute>} />

            <Route path={Paths.SITE_ADMINISTRATOR_SETTING_ID} element={<AuthRoute><SiteAdministrator /></AuthRoute>} />
            <Route path={Paths.SITE_ADMINISTRATOR_SETTING} element={<AuthRoute><SiteAdministrator /></AuthRoute>} />
            <Route path={Paths.SITE_ADMINISTRATOR} element={<AuthRoute><SiteAdministrator /></AuthRoute>} />

            <Route path={Paths.CHANNEL_INVITE} element={<ChannelInvite />} />

            <Route path={Paths.MANAGE_USERS} element={<AuthRoute><Users /></AuthRoute>} />
            <Route path={Paths.HOME} element={<Homepage />} />
            <Route path={Paths.ERROR_404} element={<Error404 />} />
            <Route path={Paths.ERROR_INTERNAL} element={<InternalError />} />

            <Route element={<Homepage />} />

        </BrowserRoutes>
    );
}

export default Routes;
